module.exports = __webpack_public_path__ + "img/kip_base.4bb1ef9b.png";